module.exports = __webpack_public_path__ + "static/media/img-problem.f2097377.png";